/* How a system is written for a person. The key is an implementation detail of the corpus
 * layout — the folders, each document's `system_id` and the telemetry rows all say
 * `unipass` — and nobody outside this codebase calls the product that.
 *
 * The names themselves come from the server, with the session: a system registered on the
 * Integrations tab carries its own display name, and that is the only place a system created
 * after this build shipped can be named from. Prefer `useApp().systemLabel`, which has that
 * table to hand; the fallback below only covers the two systems this deployment started with
 * and the case where the session was fetched by an older build.
 */

const BUILT_IN: Record<string, string> = {
  eis: 'EIS',
  unipass: 'NextPass',
  nextpass: 'NextPass',
};

/**
 * The display name for a key. Registered names win, then the built-in table, then the key
 * itself — a name nobody chose beats a blank.
 */
export const labelFor = (key: string, registered?: Record<string, string>): string => {
  const clean = (key ?? '').trim().toLowerCase();
  return registered?.[clean] ?? BUILT_IN[clean] ?? key;
};

/** A list of keys as one phrase, in the words a person uses for them. */
export const labelsOf = (
  keys: string[],
  registered?: Record<string, string>,
  separator = ', ',
): string => keys.map((key) => labelFor(key, registered)).join(separator);
